import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import {PlaceServiceBase} from 'app/core/places.service';

@Injectable()
export class ChainService extends PlaceServiceBase {
  constructor(http: Http) {
    super(http, 'chain');
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/chain/chain.service.ts